import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { assetsReducer } from './assetsReducer';
import { authReducer } from './authReducer';
import { chatReducer } from './chatReducer';
import { charactersReducer } from './charactersReducer';
import { configReducer } from './configReducer';
import { gridtoolsReducer } from './gridtoolsReducer';
import { loadingReducer } from './loadingReducer';
import { editTableReducer } from './editTableReducer';
import { filemanagerReducer } from './filemanagerReducer';
import { jukeboxReducer } from './jukeboxReducer';
import { messagesReducer } from './messagesReducer';
import { playersReducer } from './playersReducer';
import { profilesReducer } from './profilesReducer';
import { templateReducer } from './templateReducer';
import { timersReducer } from './timersReducer';
import { turnorderReducer } from './turnorderReducer';
import { rtcBufferReducer } from './rtcBufferReducer';

export const Reducers = combineReducers({
    assetsState: assetsReducer,
    authState: authReducer,
    chatState: chatReducer,
    charactersState: charactersReducer,
    configState: configReducer,
    gridtoolsState: gridtoolsReducer,
    loadingState: loadingReducer,
    editTableState: editTableReducer,
    filemanagerState: filemanagerReducer,
    jukeboxState: jukeboxReducer,
    messagesState: messagesReducer,
    playersState: playersReducer,
    profilesState: profilesReducer,
    rtcBufferState: rtcBufferReducer,
    templateState: templateReducer,
    timersState: timersReducer,
    turnorderState: turnorderReducer,
    routing: routerReducer
});